import _ from 'lodash';

const hasOwn = (values: object, key: string) =>
  Object.prototype.hasOwnProperty.call(values, key);

/** A server snapshot with the screen's values kept for the client-owned fields; `serverValues` itself if none differ. */
export const overlayClientOwnedValues = <T extends Record<string, unknown>>(
  serverValues: T,
  screenValues: Record<string, unknown>,
  ownedFieldIds: ReadonlySet<string>,
): T => {
  let effective = serverValues;

  ownedFieldIds.forEach(fieldId => {
    // Presence, not `!== undefined`: an empty server field seeds `undefined`. A key the
    // snapshot dropped stays dropped, so a branch the server hid stays hidden.
    if (!hasOwn(serverValues, fieldId) || !hasOwn(screenValues, fieldId)) return;
    if (_.isEqual(serverValues[fieldId], screenValues[fieldId])) return;

    if (effective === serverValues) effective = { ...serverValues };
    // Cloned so Formik's next edit to the screen value cannot move the new initial values.
    (effective as Record<string, unknown>)[fieldId] = _.cloneDeep(
      screenValues[fieldId],
    );
  });

  return effective;
};
